<template>
  <div class="bg-white rounded-lg shadow overflow-hidden">
    <div class="divide-y divide-gray-200">
      <!-- Profile section -->
      <div class="py-6 px-6">
        <div class="flex justify-between w-100 mb-8 sm:m-3 sm:mb-6">
          <div class="flex w-1/6">
            <!-- RIGHT -->
            <img class="px-1 md:mb-4" src="/pp/mtcontrol.svg"/>
          </div>
          <div class="flex justify-between items-center xl:w-1/6 lg:w-1/5 md:w-1/4 w-1/3 mr-4">
            <!-- LEFT -->
            <img v-if="showLogo" class="inline-flex max-h-9" :src="pathlogo"/>
            <div v-else class="w-min-100"></div>
            <div class="sm:pl-10 flex justify-end text-gray-300">
              <button v-if="showbutton" class="mr-4 text-3xl hover:text-gray-500" @click="back">
                <i class="w-100 fas fa-arrow-left"></i>
              </button>
              <button class="text-4xl hover:text-gray-500" @click="logout">
                <i class="w-100 fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <subtitle-home />
        <info-items-home />
        <div class="mt-2">
          <h2 class="text-2xl md:text-3xl 2xl:text-2xl leading-6 font-medium text-gray-900">{{fields.title}}</h2>
          <p class="mt-1 2xl:text-md xl:text-xl text-gray-500">
            {{fields.subtitle}}
          </p>
        </div>
      </div>

      <div class="mt-2 flex flex-col">
        <div class="mx-4 pb-4 p-4 lg:pb-16">
          <template v-for="field in fields.fields">
            <template v-if="!field.hidden">
              <info-field class="pb-4" v-if="field.type === 'info'" v-bind:key="field.key" :field="field"/>
              <modal-field class="pb-4" v-if="field.type === 'modal'" v-bind:key="field.key" :parentfield="field"/>
              <legend-field class="pb-4" v-if="field.type === 'legend'" v-bind:key="field.key" :field="field"  :formdata="formdata" :params="$store.state.data"/>
              <hidden-field class="pb-4" v-if="field.type === 'hidden'" v-bind:key="field.key" :field="field"  :formdata="formdata" :params="$store.state.data"/>
              <legend-list-field class="pb-4" v-if="field.type === 'legendlist'" v-bind:key="field.key" :field="field"  :formdata="formdata" :params="$store.state.data"/>
              <text-field  class="pb-4" v-if="field.type === 'text'" v-bind:key="field.key" :field="field" :formdata="formdata" :validation="validation[field.key]"/>
              <password-field  class="pb-4" v-if="field.type === 'password'" v-bind:key="field.key" :field="field" :formdata="formdata" :validation="validation[field.key]"/>
              <number-field  class="pb-4" v-if="field.type === 'number'" v-bind:key="field.key" :field="field" :formdata="formdata" :validation="validation[field.key]"/>
              <select-field  class="pb-4" v-if="field.type === 'select'" v-bind:key="field.key" :field="field" :formdata="formdata" :validation="validation[field.key]" />
              <search-option-field  class="pb-4" v-if="field.type === 'searchoption'" v-bind:key="field.key" :field="field" :formdata="formdata" />
              <search-multiple-option-field  class="pb-4" v-if="field.type === 'searchmultipleoption'" v-bind:key="field.key" :field="field" :formdata="formdata" />
              <date-picker-field class="pb-4" v-if="field.type === 'date'" v-bind:key="field.key" :field="field" :formdata="formdata"/>
              <date-time-picker-field class="pb-4" v-if="field.type === 'datetime'" v-bind:key="field.key" :field="field" :formdata="formdata" :validation="validation[field.key]"/>
              <radio-field v-if="field.type === 'radio'" v-bind:key="field.key" :field="field" :formdata="formdata"/>
              <table-field v-if="field.type === 'table'" v-bind:key="field.key" :field="field" :formdata="formdata"/>
              <upload-field v-if="field.type === 'upload'" v-bind:key="field.key" :field="field" :formdata="formdata"/>
              <complex-table-field v-if="field.type === 'complextable'" v-bind:key="field.key" :field="field" :formdata="formdata"/>
              <home-button-field v-if="field.type === 'homebutton'" v-bind:key="field.key" :field="field" :formdata="formdata"  />
              <button-field v-if="field.type === 'button'" v-bind:key="field.key" :field="field" :formdata="formdata" />
              <buttons-field v-if="field.type === 'buttons'" v-bind:key="field.key" :field="field" :formdata="formdata" :params="$store.state.data" />
            </template>
          </template>
        </div>
      </div>

      <!-- Privacy section -->
      <div class="divide-y divide-gray-200">
        <form-button  :disabled="disabled" :isSubmiting="isSubmiting"/>
      </div>
    </div>

    <confirmation-modal v-if="confirmationmodal" :msg="confirmationmodalmsg" :withpin="fields.pin"/>

  </div>
</template>
<script>
import LegendListField from '@/components/LegendListField'
import LegendField from '@/components/LegendField'
import InfoField from '@/components/InfoField'
import ModalField from '@/components/ModalField'
import TextField from '@/components/TextField'
import PasswordField from '@/components/PasswordField'
import NumberField from '@/components/NumberField'
import UploadField from '@/components/UploadField'
import SelectField from '@/components/SelectField'
import SearchOptionField from '@/components/SearchOptionField'
import SearchMultipleOptionField from '@/components/SearchMultipleOptionField'
import RadioField from '@/components/RadioField'
import DatePickerField from '@/components/DatePickerField'
import DateTimePickerField from '@/components/DateTimePickerField'
import TableField from '@/components/TableField'
import ComplexTableField from '@/components/ComplexTableField'
import ConfirmationModal from '@/components/ConfirmationModal'
import FormButton from '@/components/FormButton'
import HiddenField from '@/components/HiddenField'
import HomeButtonField from '@/components/HomeButtonField'
import ButtonField from '@/components/ButtonField'
import ButtonsField from '@/components/ButtonsField'
import InfoItemsHome from '@/components/InfoItemsHome'
import SubtitleHome from '@/components/SubtitleHome'

import axios from 'axios';

export default {
  name: 'dynamic-form',
  components: {
    LegendField,
    LegendListField,
    InfoField,
    ModalField,
    TextField,
    PasswordField,
    NumberField,
    UploadField,
    HomeButtonField,
    SelectField,
    ButtonField,
    ButtonsField,
    SubtitleHome,
    FormButton,
    SearchOptionField,
    DatePickerField,
    DateTimePickerField,
    SearchMultipleOptionField,
    RadioField,
    TableField,
    ComplexTableField,
    InfoItemsHome,
    ConfirmationModal,
    HiddenField
  },
  data() {
    return {
      formdata: {},
      urlparams: {},
      date: new Date(),
      validation: {},
      fields: [],
      legends: {},
      isSubmiting: false,
      createdts: null,
      disabled: true,
      showLogo: false,
      showbutton: false,
      pathlogo: '',
      uploadfiles: [],
      confirmationmodal: false,
      confirmationmodalmsg: 'Está Seguro?',
      windowWidth: window.innerWidth
    }
  },

  async created() {
    await this.showButton()
    this.createdts = new Date();
    await this.getFormFields()
    await this.getInitialValues()
    this.getLogo()
  },
  mounted() {
    window.onresize = () => {
        this.windowWidth = window.innerWidth
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    this.urlparams = Object.fromEntries(urlSearchParams.entries());
    console.log('params:', this.urlparams)
  },
  methods: {
    async showButton(){
      const response = await this.$http.get('flow/custom/formbuttons?method=back')
      if(JSON.stringify(response.data) !== "{}") {
        this.showbutton = true
      }
    },

    async getLogo(){
      const exts = ['svg', 'png', 'jpg']
      for (const ext of exts){
        this.checkIfImageExists(`/pp/${this.$store.state.auth.client}_logo.${ext}`, (exists) => {
          if (exists) {
            this.showLogo = exists
            this.pathlogo = `/pp/${this.$store.state.auth.client}_logo.${ext}`
            return
          } else {
            this.showLogo = exists
          }
        })
      }
    },
    checkIfImageExists(url, callback) {
      const img = new Image();
      img.src = url;

      if (img.complete) {
        callback(true);
      } else {
        img.onload = () => {
          callback(true);
        };

        img.onerror = () => {
          callback(false);
        };
      }
    },
    async getFormFields() {
      let config = {
        params: this.$store.state.data.data
      }
      this.$http.get(`forms?form=flowform&params=${this.$route.params.blueprint}`, config).then(response => {
        // Handle success.
          this.fields = response.data
          this.checkRequired()
        })
        .catch(error => {
          // Handle error.
          if (error.response.status === 401) {
            this.$router.push('/')
            this.$router.go()
          }
        });
    },

    async getInitialValues() {
      if (this.$route.params.record !== '0') {
        console.log('getInitialValues!', this.$route.params.record)
        let config = {
          params: this.$store.state.data.data
        }
        const response = await this.$http.get(`flow/records/${this.$route.params.record}`, config)
        console.log(response.data.data.data)
        if (response.data.data.data !== undefined) {
          Object.entries(response.data.data.data).forEach(item => {
            this.formdata[item[0]] = item[1]['value']
            this.formdata = JSON.parse(JSON.stringify(this.formdata))
          })
        }
      }
    },

    updateValue(key, value) {
      this.formdata[key] = JSON.parse(JSON.stringify(value))
      
      // Recursively clear all dependent field values
      this.clearDependentFields(key)
      
      this.formdata = JSON.parse(JSON.stringify(this.formdata))

      if(key === 'order'){
        this.$store.commit('setState', { 'selectedOrder': value })
      }

      this.checkRequired()
    },

    clearDependentFields(parentKey) {
      // Find all fields that depend on the parentKey
      this.fields.fields.forEach(field => {
        if (field.depends === parentKey) {
          // Clear this field's value
          delete this.formdata[field.key]
          // Recursively clear any fields that depend on this field
          this.clearDependentFields(field.key)
        }
      })
    },

    addUploadFile(key, filelist) {
      console.log('addUploadFile', filelist)
      this.uploadfiles = filelist
    },

    deleteValue(key) {
      delete this.formdata[key]
    },

    checkRequired() {
      // Check for required
      const requiredlist = this.fields.fields.filter(function (el) {
        return el.required === true
      })

      this.disabled = false
      if (requiredlist.length > 0) {
        requiredlist.forEach(element => {
          if (this.formdata[element.key] === undefined || this.formdata[element.key] === 'Seleccione opción') {
            this.disabled = true
          }
        })
      }
    },

    checkConfirmation() {
      if (this.fields.confirmationmodalmsg !== undefined) {
        this.confirmationmodalmsg = this.fields.confirmationmodalmsg
        this.confirmationmodal = true
      } else {
        this.submitForm()
      }
    },

    confirmSubmit() {
      this.submitForm()
    },

    async submitForm() {
      this.isSubmiting = true
      this.disabled = true

      const data = {
        formdata: this.formdata,
        fields: this.fields.fields,
        params: {
          ...this.$store.state.data,
          urlparams: this.urlparams,
          blueprintid: this.$route.params.blueprint,
          recordid: this.$route.params.record,
          createdts: this.createdts.getTime() / 1000
        }
      }

      let payload = {
        data: data,
        form: 'flowform',
      }
      try {

        if (this.uploadfiles.length > 0) {
          const filename = await this.uploadFiles();
          payload.data.params.filename = filename;
        }

        const response = await this.$http.post(`forms?blueprintid=${this.$route.params.blueprint}`, payload)
        this.isSubmiting = false

        if (response.data.data !== undefined && response.data.data.store !== undefined) {
          this.$store.commit('setState', response.data.data.store)
        }

        if (response.data !== undefined && response.data.validation !== undefined) {
          console.log(response.data.validation)
          this.confirmationmodal = false
          let val = {}
          response.data.validation.forEach(obj => val[obj.key] = obj)
          this.validation = val
          console.log(this.validation)
          return
        }


        if (response.data.data !== undefined && response.data.data.jump !== undefined) {
          if (response.data.data.jump === 'notjump') {
            this.confirmationmodal = false
          }
          if (response.data.data.jump === 'logout')  {
            this.$router.push('/')
            this.$router.go()
          } else if(response.data.data.jump !== 'notjump'){
            var jump = '/form/' + response.data.data.jump
            if (response.data.data.recordid !== undefined){
              jump = jump + '/' + response.data.data.recordid
            } else {
              jump = jump + "/0"
            }

            if (response.data.data.params !== undefined){
              jump = jump + response.data.data.params
            }

            this.$router.push(jump)
            this.$router.go()
          }
        } else {
          this.$router.push('/home')
        }
        this.disabled = false
      } catch (error){
        console.error(error)
        this.isSubmiting = false
      }

    },

    async uploadFiles() {
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        }
      }
      let formData = new FormData()
      this.uploadfiles.forEach ((file) => {
        formData.append('files[]', file)
        console.log(file)
      })
      formData.append('blueprint', this.$route.params.blueprint)
      formData.append('formdata', JSON.stringify(this.formdata))

      try {
        const response = await this.$http.post('flow/custom/uploadfile', formData, config)
        console.log('upload response:', response.data)
        const filename = response.data
        return filename;
      } catch (error) {
        console.error(error)
      }
    },

    async downloadFile(button) {
      this.isSubmiting = true
      let config = {
        params: {
          ...this.$store.state.data,
          record: this.$route.params.record,
          blueprint: this.$route.params.blueprint,
          formdata: this.formdata
        }
      }
      try {
        const response = await this.$http.get(button.options_button.url, config);
        const baseURL = process.env.VUE_APP_ROOT_API;
        const url = `${baseURL}/reports?report=getfile&filename=${response.data}`
        await axios
          .get(`${url}`, { responseType: 'blob', headers: {'Authorization': `JWT ${this.$store.getters.auth.token}`} })
          .then(async res => ({
            blob: await new Blob([res.data], {
              type: 'application/pdf'
            }),
            filename: response.data
          }))
          .then(res => {
            console.log(res);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(res.blob);
            link.download = res.filename;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      } catch (error) {
        console.error(error)
      }

      this.isSubmiting = false
    },
    goBack(button) {
      console.log('goBack', button)
      this.$router.go(-1)
    },
    goTo(button){
      console.log('goTo')
      this.$router.push(button.options_button.push)
      this.$router.go()
    },
    async runInApi(button){
      console.log('runInApi')
      this.isSubmiting = true
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          ...this.params,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          query: this.$route.query
        }
      }
      try {
        const response = await this.$http.get(button.options_button.url, config)
        this.isSubmiting = false
        if (response.data.data !== undefined && response.data.data.store !== undefined) {
            this.$store.commit('setState', response.data.data.store)
           }
        if (response.data.push !== undefined){
          console.log(response.data);
          this.$router.push(response.data.push)
          this.$router.go()
        }
      } catch (error) {
        console.error(error)
      }
      this.isSubmiting = false

    },

    checkConfirmationReject() {
      if (this.fields.confirmationmodalmsg !== undefined) {
        this.confirmationmodalmsg = this.fields.confirmationmodalmsg
        this.confirmationmodal = true
      } else {
        this.submitForm()
      }
    },

    async back() {
      let config = {
        params: {
          blueprint: this.$route.params.blueprint
        }
      }
      const response = await this.$http.get('flow/custom/formbuttons?method=back', config)
      if(response.data.jump === '') return
      this.$router.push(response.data.jump)
      this.$router.go()
    },

    async logout() {
      let config = {
        params: {
          blueprint: this.$route.params.blueprint
        }
      }
      const response = await this.$http.get('flow/custom/formbuttons?method=logout', config)
      this.$router.push(response.data.jump)
      this.$router.go()
    },

  }
}
</script>
